import { doc, getFirestore, deleteDoc } from 'firebase/firestore';

const deleteProduct = async (productId: any) => {
  const db = getFirestore();
  const productRef = doc(db, 'products', productId);
  deleteDoc(productRef);
};

export default deleteProduct;
